import { render, staticRenderFns } from "./filter_item.vue?vue&type=template&id=27dc4f5a&scoped=true&"
import script from "./filter_item.vue?vue&type=script&lang=js&"
export * from "./filter_item.vue?vue&type=script&lang=js&"
import style0 from "./filter_item.vue?vue&type=style&index=0&id=27dc4f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc4f5a",
  null
  
)

export default component.exports